import { useEffect, useMemo } from "react";
import { debounce } from "lodash";

export const useDebounce = (value, delay = 500) => {
  const debouncedFunc = useMemo(() => debounce(value, delay), [value, delay]);

  useEffect(() => {
    return () => debouncedFunc.cancel();
  }, [debouncedFunc]);

  return debouncedFunc;
};
